import * as create from "./create";
import * as edit from "./edit";
import * as detail from "./detail";

import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import INFSe from "Types/INFSe";
import _, { chunk } from "lodash";

import { saveAs } from "file-saver";
import JSZip from "jszip";

export const GET_NFSES = "[NFSE] GET_NFSES";
export const GET_NFSES_SUCCESS = "[NFSE] GET_NFSES_SUCCESS";
export const GET_NFSES_FAILED = "[NFSE] GET_NFSES_FAILED";

export const DOWNLOAD_NFSES = "[NFSE] DOWNLOAD_NFSES";
export const DOWNLOAD_NFSES_SUCCESS = "[NFSE] DOWNLOAD_NFSES_SUCCESS";
export const DOWNLOAD_NFSES_FAILED = "[NFSE] DOWNLOAD_NFSES_FAILED";

export const IMPORT_NFSES = "[NFSE] IMPORT_NFSES";
export const IMPORT_NFSES_SUCCESS = "[NFSE] IMPORT_NFSES_SUCCESS";
export const IMPORT_NFSES_FAILED = "[NFSE] IMPORT_NFSES_FAILED";

export const RETRY_NFSE = "[NFSE] RETRY_NFSE";
export const RETRY_NFSE_SUCCESS = "[NFSE] RETRY_NFSE_SUCCESS";
export const RETRY_NFSE_FAILED = "[NFSE] RETRY_NFSE_FAILED";

export const CANCEL_NFSE = "[NFSE] CANCEL_NFSE";
export const CANCEL_NFSE_SUCCESS = "[NFSE] CANCEL_NFSE_SUCCESS";
export const CANCEL_NFSE_FAILED = "[NFSE] CANCEL_NFSE_FAILED";
export const BULK_CANCEL_NFSE = "[NFSE] BULK_CANCEL_NFSE";
export const BULK_CANCEL_NFSE_SUCCESS = "[NFSE] BULK_CANCEL_NFSE_SUCCESS";
export const BULK_CANCEL_NFSE_FAILED = "[NFSE] BULK_CANCEL_NFSE_FAILED";

export const SET_VALUE = "[NFSE EDIT] SET_VALUE";
export const CLEAR_VALUES = "[NFSE EDIT] CLEAR_VALUES";

export { create, edit, detail };

export function setValue(payload: any) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function importNFSes(data?: any[], callback?: Callback<INFSe[]>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: IMPORT_NFSES });

		try {
			const { login } = getState();

			const chunks = _.chunk(data, 100);

			let response: Response | any = null;

			for (const chunk of chunks) {
				response = await api.sendPost("/NFSe/Import", chunk, {
					Authorization: `Bearer ${login.token}`
				});
			}

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: IMPORT_NFSES_SUCCESS
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: IMPORT_NFSES_FAILED,
					payload: errors
				});

				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: IMPORT_NFSES_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function retry(id: string | string[], callback?: Callback<INFSe[]>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: RETRY_NFSE });

		try {
			const { login } = getState();

			let response: Response;
			if (Array.isArray(id)) {
				response = await api.sendPost(`/NFSe/Retry`, id, {
					Authorization: `Bearer ${login.token}`
				});
			} else {
				response = await api.sendPost(`/NFSe/${id}/Retry`, null, {
					Authorization: `Bearer ${login.token}`
				});
			}

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: RETRY_NFSE_SUCCESS
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: RETRY_NFSE_FAILED,
					payload: errors
				});

				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: RETRY_NFSE_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function cancel(id: string, motivoCancelamento: number, justificativa: string, callback?: Callback<void>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: CANCEL_NFSE });

		try {
			const { login } = getState();

			const response = await api.sendPost(`/NFSe/${id}/Cancel`, {
				motivoCancelamento,
				justificativa
			}, {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: CANCEL_NFSE_SUCCESS
				});

				callback && callback(null);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: CANCEL_NFSE_FAILED,
					payload: errors
				});

				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: CANCEL_NFSE_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function bulkCancel(ids: string[], motivoCancelamento: number, justificativa: string, callback?: Callback<void>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: BULK_CANCEL_NFSE });

		try {
			const { login } = getState();

			const response = await api.sendPost(`/NFSe/BulkCancel`, {
				ids,
				motivoCancelamento,
				justificativa
			}, {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: BULK_CANCEL_NFSE_SUCCESS
				});

				callback && callback(null);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: BULK_CANCEL_NFSE_FAILED,
					payload: errors
				});

				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: BULK_CANCEL_NFSE_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function getNFSes(
	skip: number = 0,
	take: number = 10,
	filter?: string,
	sort?: string,
	desc?: boolean,
	toExport?: boolean,
	callback?: Callback<INFSe[]>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_NFSES });

		try {
			const { login } = getState();

			const response = await api.sendGet(
				`/NFSe?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${
					filter || "&filters=null"
				}`,
				{
					Authorization: `Bearer ${login.token}`
				}
			);

			const result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_NFSES_SUCCESS,
						payload: result.model
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / (take || 10)),
								...result.params
							})
						);
				}

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_NFSES_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_NFSES_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function downloadNFSes(filter?: any[], callback?: Callback<void>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: DOWNLOAD_NFSES });

		try {
			const { login, nfse } = getState();

			const totalCount = nfse.count;
			const maxItemsPerRequest = 1000; // API limit

			// Collect all NFSe items from multiple pages
			const allNFSeItems: INFSe[] = [];
			let skip = 0;
			let pageNumber = 1;

			while (skip < totalCount) {
				const take = Math.min(maxItemsPerRequest, totalCount - skip);

				const response = await api.sendGet(
					`/NFSe?skip=${skip}&take=${take}${filter || "&filters=null"}`,
					{
						Authorization: `Bearer ${login.token}`
					}
				);

				if (!response.ok) {
					throw new Error(`Failed to fetch NFSe page ${pageNumber}: ${response.status}`);
				}

				const result = await response.json();
				allNFSeItems.push(...result.model);
				
				skip += take;
				pageNumber++;
			}

			if (allNFSeItems.length > 0) {
				const zip = new JSZip();
				const usedFilenames = new Set<string>();

				// Function to generate unique filename
				const getUniqueFilename = (baseFilename: string): string => {
					if (!usedFilenames.has(baseFilename)) {
						usedFilenames.add(baseFilename);
						return baseFilename;
					}

					// Extract name and extension
					const lastDotIndex = baseFilename.lastIndexOf('.');
					const name = lastDotIndex !== -1 ? baseFilename.substring(0, lastDotIndex) : baseFilename;
					const extension = lastDotIndex !== -1 ? baseFilename.substring(lastDotIndex) : '';

					let counter = 2;
					let uniqueFilename = `${name}-${counter}${extension}`;
					
					while (usedFilenames.has(uniqueFilename)) {
						counter++;
						uniqueFilename = `${name}-${counter}${extension}`;
					}
					
					usedFilenames.add(uniqueFilename);
					return uniqueFilename;
				};

				const chunks = chunk<INFSe>(allNFSeItems, 10);

				for (const chunk of chunks) {
					await Promise.all(
						chunk.map(
							nfse =>
								new Promise(async res => {
									try {
										const [pdfRes, xmlRes] = await Promise.allSettled([
											nfse.pdf ? fetch(nfse.pdf) : Promise.resolve(null),
											nfse.xml ? fetch(nfse.xml) : Promise.resolve(null)
										]);

										const [pdf, xml] = await Promise.allSettled([
											pdfRes.status === 'fulfilled' && pdfRes.value ? pdfRes.value.blob() : Promise.resolve(null),
											xmlRes.status === 'fulfilled' && xmlRes.value ? xmlRes.value.blob() : Promise.resolve(null)
										]);

										if (pdf.status === 'fulfilled' && pdf.value) {
											const uniquePdfFilename = getUniqueFilename(`${nfse.filename}.pdf`);
											zip.file(uniquePdfFilename, pdf.value);
										}
										if (xml.status === 'fulfilled' && xml.value) {
											const uniqueXmlFilename = getUniqueFilename(`${nfse.filename}.xml`);
											zip.file(uniqueXmlFilename, xml.value);
										}
									} catch (error) {
										// Log error but continue processing other files
										console.warn(`Error downloading files for NFSe ${nfse.filename}:`, error);
									}

									res(null);
								})
						)
					);
				}

				const zipBlob = await zip.generateAsync({ type: "blob" });

				saveAs(zipBlob, `NFSe-${new Date().getTime()}.zip`);

				dispatch({
					type: DOWNLOAD_NFSES_SUCCESS
				});

				// Show success modal
				if (callback) {
					callback({
						type: 'success',
						title: 'Download Concluído',
						message: `Arquivo ZIP gerado com sucesso! ${allNFSeItems.length} NFSe(s) processadas.`,
						details: `Total de arquivos: ${allNFSeItems.length * 2} (${allNFSeItems.length} PDFs + ${allNFSeItems.length} XMLs)`
					});
				}
			} else {
				dispatch({
					type: DOWNLOAD_NFSES_FAILED
				});

				// Show error modal
				if (callback) {
					callback({
						type: 'error',
						title: 'Nenhum Item Encontrado',
						message: 'Não foram encontrados NFSe items para download.',
						details: 'Verifique os filtros aplicados e tente novamente.'
					});
				}
			}
		} catch (error) {
			dispatch({
				type: DOWNLOAD_NFSES_FAILED,
				payload: {
					error: "Connection error"
				}
			});

			// Show error modal
			if (callback) {
				callback({
					type: 'error',
					title: 'Erro no Download',
					message: 'Ocorreu um erro durante o download dos arquivos.',
					details: error instanceof Error ? error.message : 'Erro desconhecido'
				});
			}
		}
	};
}

export function downloadSelectedNFSes(selectedIds: string[], callback?: Callback<void>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: DOWNLOAD_NFSES });

		try {
			const { login, nfse } = getState();

			// Get the selected NFSE items from the current state
			const selectedNFSeItems = nfse.items.filter((item: INFSe) => 
				item._id && selectedIds.includes(item._id) && item._id !== "all"
			);

			console.log('Selected NFSE items:', selectedNFSeItems);
			console.log('Selected IDs:', selectedIds);

			if (selectedNFSeItems.length === 0) {
				callback && callback({
					title: 'Nenhum item selecionado',
					message: 'Não há NFSe selecionadas para download.',
					details: 'Selecione pelo menos uma NFSe para fazer o download.'
				});
				return;
			}

			if (selectedNFSeItems.length > 0) {
				const zip = new JSZip();
				const usedFilenames = new Set<string>();

				// Function to generate unique filename
				const getUniqueFilename = (baseFilename: string): string => {
					if (!usedFilenames.has(baseFilename)) {
						usedFilenames.add(baseFilename);
						return baseFilename;
					}

					// Extract name and extension
					const lastDotIndex = baseFilename.lastIndexOf('.');
					const name = lastDotIndex !== -1 ? baseFilename.substring(0, lastDotIndex) : baseFilename;
					const extension = lastDotIndex !== -1 ? baseFilename.substring(lastDotIndex) : '';

					// Find next available number
					let counter = 1;
					let newFilename: string;
					do {
						newFilename = `${name}_${counter}${extension}`;
						counter++;
					} while (usedFilenames.has(newFilename));

					usedFilenames.add(newFilename);
					return newFilename;
				};

				// Download files for each NFSe using the same robust approach as the existing download
				const chunks = chunk<INFSe>(selectedNFSeItems, 10);

				for (const chunk of chunks) {
					await Promise.all(
						chunk.map(
							nfse =>
								new Promise(async res => {
									try {
										const [pdfRes, xmlRes] = await Promise.allSettled([
											nfse.pdf ? fetch(nfse.pdf) : Promise.resolve(null),
											nfse.xml ? fetch(nfse.xml) : Promise.resolve(null)
										]);

										const [pdf, xml] = await Promise.allSettled([
											pdfRes.status === 'fulfilled' && pdfRes.value ? pdfRes.value.blob() : Promise.resolve(null),
											xmlRes.status === 'fulfilled' && xmlRes.value ? xmlRes.value.blob() : Promise.resolve(null)
										]);

										if (pdf.status === 'fulfilled' && pdf.value) {
											const uniquePdfFilename = getUniqueFilename(`${nfse.filename}.pdf`);
											zip.file(uniquePdfFilename, pdf.value);
										}
										if (xml.status === 'fulfilled' && xml.value) {
											const uniqueXmlFilename = getUniqueFilename(`${nfse.filename}.xml`);
											zip.file(uniqueXmlFilename, xml.value);
										}
									} catch (error) {
										// Log error but continue processing other files
										console.warn(`Error downloading files for NFSe ${nfse.filename}:`, error);
									}

									res(null);
								})
						)
					);
				}

				// Generate and download the ZIP file
				console.log('Generating ZIP file...');
				const zipBlob = await zip.generateAsync({ type: "blob" });
				console.log('ZIP file generated, size:', zipBlob.size);
				saveAs(zipBlob, `NFSe-${new Date().getTime()}.zip`);
				console.log('ZIP file download initiated');

				dispatch({
					type: DOWNLOAD_NFSES_SUCCESS
				});

				callback && callback({
					title: 'Download Concluído',
					message: `Arquivo ZIP gerado com sucesso! ${selectedNFSeItems.length} NFSe(s) selecionadas processadas.`,
					details: `Total de arquivos: ${selectedNFSeItems.length * 2} (${selectedNFSeItems.length} PDFs + ${selectedNFSeItems.length} XMLs)`
				});
			} else {
				dispatch({
					type: DOWNLOAD_NFSES_SUCCESS
				});

				callback && callback({
					title: 'Nenhum arquivo encontrado',
					message: 'Não foram encontrados arquivos para download das NFSe selecionadas.',
					details: 'Verifique se as NFSe selecionadas possuem arquivos PDF e XML disponíveis.'
				});
			}
		} catch (error) {
			dispatch({
				type: DOWNLOAD_NFSES_FAILED,
				payload: {
					error: "Connection error"
				}
			});

			callback && callback({
				title: 'Erro no Download',
				message: 'Ocorreu um erro durante o download dos arquivos selecionados.',
				details: error instanceof Error ? error.message : 'Erro desconhecido'
			});
		}
	};
}
